module.exports = __webpack_public_path__ + "img/img13.40ca0d89.svg";